export default __webpack_public_path__ + "static/media/hu.e6a8aa4d.svg";